'use client';

import {
  Bot,
  Download,
  LayoutDashboard,
  LayoutTemplate,
  Library,
  ScrollText,
  Settings,
  Video,
  Wand2,
  Wrench,
} from 'lucide-react';
import { SageNavIcon } from '@/components/support/sage-nav-icon';

import { getLandingCopy } from '@/lib/marketing-copy';

import { ModeConfig } from './config';

const creatorsCopy = getLandingCopy('creators');

export const creatorMode: ModeConfig = {
  id: 'creator',
  name: 'Creator',
  sidebarNav: [
    { name: 'Inbox', href: '/dashboard', icon: LayoutDashboard, messageKey: 'app.nav.inbox', section: 'workspace' },
    { name: 'Transcribe', href: '/dashboard/transcribe', icon: ScrollText, messageKey: 'app.nav.transcribe', section: 'workspace' },
    { name: 'Episodes', href: '/dashboard/transcriptions', icon: ScrollText, messageKey: 'app.nav.episodes', section: 'workspace' },
    { name: 'Library', href: '/dashboard/library', icon: Library, messageKey: 'app.nav.library', section: 'workspace' },
    { name: 'Meetings', href: '/dashboard/meetings', icon: Video, messageKey: 'app.nav.meetings', section: 'workspace' },
    { name: 'Create', href: '/dashboard/repurpose', icon: Wand2, section: 'tools' },
    { name: 'Export', href: '/dashboard/export', icon: Download, section: 'tools' },
    { name: 'Free tools', href: '/dashboard/tools', icon: Wrench, section: 'tools' },
    { name: 'Support', href: '/dashboard/support', icon: SageNavIcon, messageKey: 'app.nav.support', section: 'account' },
    { name: 'Settings', href: '/dashboard/settings', icon: Settings, messageKey: 'app.nav.settings', section: 'account' },
  ],
  transcriptTabs: [
    { id: 'transcript', label: 'Transcript', icon: ScrollText, messageKey: 'app.tabs.transcript' },
    { id: 'summary', label: 'AI Summary', icon: Bot, messageKey: 'app.tabs.summary' },
    { id: 'chapters', label: 'Chapters', icon: LayoutTemplate, messageKey: 'app.tabs.chapters' },
  ],
  landingPage: {
    hero: {
      title: creatorsCopy.hero.heading,
      description: creatorsCopy.hero.subhead,
      cta: {
        primary: creatorsCopy.hero.primaryCta.label,
        secondary: creatorsCopy.hero.secondaryCta?.label,
      },
    },
    features: (creatorsCopy.features ?? []).map((feature) => ({
      title: feature.title,
      description: feature.description,
    })),
  },
  routes: {
    dashboard: '/dashboard',
    upload: '/dashboard/upload',
    transcriptions: '/dashboard/transcriptions',
    success: '/dashboard?checkout=success',
  },
};
